// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as AcademyParallaxTypes$LiteracyplanetClientSxEntry from "./AcademyParallaxTypes.res.mjs";
import * as AcademyParallaxQueries$LiteracyplanetClientSxEntry from "./AcademyParallaxQueries.res.mjs";

function AcademyParallaxData$Provider(props) {
  var onPlayActivity = props.onPlayActivity;
  var match = React.useState(function (param) {
        
      });
  var setCategory = match[1];
  var match$1 = React.useState(function (param) {
        return 0;
      });
  var setActiveCategoryWindow = match$1[1];
  var match$2 = React.useState(function (param) {
        return "LEVEL_0";
      });
  var setLevel = match$2[1];
  var currentLevel = match$2[0];
  var match$3 = React.useState(function (param) {
        return "NoLoading";
      });
  var setLoadNextWindow = match$3[1];
  var query = AcademyParallaxQueries$LiteracyplanetClientSxEntry.use(props.md5, currentLevel, match[0]);
  React.useEffect((function (param) {
          if (query.loading) {
            
          } else {
            Curry._1(setLoadNextWindow, (function (param) {
                    return "NoLoading";
                  }));
          }
        }), [query.loading]);
  var onClickLevel = function (level) {
    Curry._1(setCategory, (function (param) {
            
          }));
    Curry._1(setLevel, (function (param) {
            return level;
          }));
  };
  var onClickActivity = function (activity) {
    Curry._2(onPlayActivity, activity.id, activity.title);
  };
  var onClickCategory = function (category, index) {
    var setLoadWindowAndCategory = function (loadWindow) {
      Curry._1(setLoadNextWindow, (function (param) {
              return loadWindow;
            }));
      Curry._1(setCategory, (function (param) {
              return category;
            }));
    };
    var last = Belt_Array.get(query.breadcrumb, query.breadcrumb.length - 1 | 0);
    if (last !== undefined && last.id !== category.parentId) {
      if (Belt_Array.some(query.breadcrumb, (function (bc) {
                return bc.id === category.id;
              }))) {
        return Curry._1(setLoadNextWindow, (function (param) {
                      return {
                              TAG: "NavigateToWindow",
                              _0: index + 1 | 0
                            };
                    }));
      } else {
        return setLoadWindowAndCategory({
                    TAG: "ReplaceExistingWindow",
                    _0: index + 1 | 0
                  });
      }
    } else {
      return setLoadWindowAndCategory({
                  TAG: "LoadNewWindow",
                  _0: index + 1 | 0
                });
    }
  };
  var onClickBreadcrumb = function (index) {
    Curry._1(setLoadNextWindow, (function (param) {
            return {
                    TAG: "NavigateToWindow",
                    _0: index
                  };
          }));
  };
  var onActiveCategoryWindowChanged = function (i) {
    Curry._1(setActiveCategoryWindow, (function (param) {
            return i;
          }));
  };
  return React.createElement(AcademyParallaxTypes$LiteracyplanetClientSxEntry.Provider.make, {
              value: {
                query: query,
                currentLevel: currentLevel,
                activeCategoryWindow: match$1[0],
                onActiveCategoryWindowChanged: onActiveCategoryWindowChanged,
                onClickCategory: onClickCategory,
                onClickBreadcrumb: onClickBreadcrumb,
                onClickActivity: onClickActivity,
                onClickLevel: onClickLevel,
                loadWindow: match$3[0]
              },
              children: props.children
            });
}

var Provider = {
  make: AcademyParallaxData$Provider
};

export {
  Provider ,
}
/* react Not a pure module */
